module.exports = __webpack_public_path__ + "static/img/4ed4b19af0c80b9652d9.685f3c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4ed4b19af0c80b9652d9.jpg
// module id = bvO8
// module chunks = 1